export default __webpack_public_path__ + "static/media/innov_indetail_illusHeader_tall375.ca66a38d.png";